/** Entry point for the /v3/api-docs/labelEdits page. */

// apiDocs.js reads these for the download buttons.
Object.assign(document.documentElement.dataset, { apiBaseUrl: '/v3/api', apiEndpoint: 'labelEdits' });
